import { render, staticRenderFns } from "./MewSwitch.vue?vue&type=template&id=b6fdd9bc"
import script from "./MewSwitch.vue?vue&type=script&lang=js"
export * from "./MewSwitch.vue?vue&type=script&lang=js"
import style0 from "./MewSwitch.vue?vue&type=style&index=0&id=b6fdd9bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports